import Lookup from 'src/componentes/select-async';
import ItemLookupMulti from 'src/componentes/item-multi-lookup';

import SearchComponent from './SearchComponent';

const ColaboradorEGrupoSimplificadoLookup = ({
  disabled,
  exibirGrupos = false,
  abrirEmDrawer = false,
  drawerPosition = 'right',
  drawerSize = 800,
  drawerZIndex = 12000,
  tituloSearchComponent,
  labelComoTitulo = false,
  ignorePermissions = false,
  parametersSearchComponent = {},
  ...rest
}) => {
  const renderItemComponent = (item) => {
    const value = item.value;
    const isValid =
      value && (typeof value === 'object' ? value.id : value.length > 0);

    if (!isValid) return '';

    const isGroup = value.identificadorLista === 'grupos';

    return (
      <ItemLookupMulti
        avatar={!isGroup}
        disabled={disabled}
        foto={value.fotoArquivo}
        onlyAvatar={false}
        label={value.descricao ?? value.nome}
        customClassname={
          isGroup ? 'bg-primary-light border border-primary' : ''
        }
        onRemove={(e) => {
          if (e && typeof e.stopPropagation === 'function') {
            e.stopPropagation();
            e.preventDefault();
          }

          if (disabled) return;

          if (item.onRemove) {
            item.onRemove(value);
          } else {
            if (rest.model && typeof rest.model.requestChange === 'function') {
              rest.model.requestChange(null);
            }
          }
        }}
      />
    );
  };

  return (
    <Lookup
      compactMultiShowAvatar={(item) => item.identificadorLista !== 'grupos'}
      showSearch
      disabled={disabled}
      labelKey={exibirGrupos ? 'descricao' : 'nome'}
      valueKey={exibirGrupos ? 'idLookup' : 'id'}
      url={
        exibirGrupos
          ? '/ColaboradorEGrupoColaboradoresLookup'
          : '/ColaboradorLookup'
      }
      searchComponent={SearchComponent}
      valueComponent={renderItemComponent}
      parametersSearchComponent={{
        ...parametersSearchComponent,
        abrirEmDrawer,
        drawerPosition,
        drawerSize,
        drawerZIndex,
        exibirGrupos,
        ignorePermissions,
        tituloSearchComponent: labelComoTitulo
          ? rest.model?.label
          : tituloSearchComponent,
      }}
      {...rest}
    />
  );
};

export default ColaboradorEGrupoSimplificadoLookup;
